import { FC } from "react"
import { Layout } from "../../../../../_webui/layout/components/Layout"
import { Translate } from "../../../../../constant/Translate"
import { useAttentionsList } from "./modules/useList"
import { AttentionsTable } from "../../components/list/Table"
import { AttentionsFormSearch } from "../../components/list/FormSearch"

const { TEXT_T331 } = Translate

export const AttentionsList: FC = () => {
  const {
    attentionInfoList,
    breadcrumbItems,
    categoryList,
    columns,
    form,
    goToAttentionsDetail,
    goToAttentionsInfo,
    isDisabledDetailBtn,
    isDisabledResponseBtn,
    isDisabledResponseHistoryBtn,
    isHiddenDetailBtn,
    isHiddenResponseBtn,
    isHiddenResponseHistoryBtn,
    isLoading,
    isLoadingLayout,
    isOpen,
    onBlur,
    onCancelPopup,
    onChange,
    onFinish,
    onKeyDown,
    onOpenPopup,
    perItem,
    rowSelection,
    severityList,
    statusList,
  } = useAttentionsList()

  return (
    <Layout
      breadcrumbItems={breadcrumbItems}
      isLoadingLayout={isLoadingLayout}
      title={TEXT_T331}
    >
      <AttentionsTable
        attentionInfoList={attentionInfoList}
        columns={columns}
        goToAttentionsDetail={goToAttentionsDetail}
        goToAttentionsInfo={goToAttentionsInfo}
        isDisabledDetailBtn={isDisabledDetailBtn}
        isDisabledResponseBtn={isDisabledResponseBtn}
        isDisabledResponseHistoryBtn={isDisabledResponseHistoryBtn}
        isHiddenDetailBtn={isHiddenDetailBtn}
        isHiddenResponseBtn={isHiddenResponseBtn}
        isHiddenResponseHistoryBtn={isHiddenResponseHistoryBtn}
        isLoading={isLoading}
        onChange={onChange}
        onOpen={onOpenPopup}
        perItem={perItem}
        rowSelection={rowSelection}
      />
      <AttentionsFormSearch
        categoryList={categoryList}
        form={form}
        isOpen={isOpen}
        onBlur={onBlur}
        onCancel={onCancelPopup}
        onFinish={onFinish}
        onKeyDown={onKeyDown}
        severityList={severityList}
        statusList={statusList}
      />
    </Layout>
  )
}
